import * as t from 'io-ts';
import fromEnum from '@/scripts/io-ts/fromEnum';

export enum HintType {
    WARNING = 'warning',
    TIP = 'tip',
}

const HintTypeC = fromEnum('HintType', HintType);

export enum HintPosition {
    BEFORE = 'before',
    AFTER = 'after',
}

export enum HintCondition {
    ALWAYS = 'always',
    FIELD_CHANGED = 'fieldChanged',
}

export const HintC = t.intersection([t.type({
    type: HintTypeC,
    title: t.string,
    description: t.string,
}), t.partial({
    position: fromEnum('HintPosition', HintPosition),
    condition: fromEnum('HintCondition', HintCondition),
})]);

export type Hint = t.TypeOf<typeof HintC>;
